module.exports = __webpack_public_path__ + "static/Bitfinex-0b65d8f4de23ee594970461fc8e253ee.png";